module.exports = __webpack_public_path__ + "img/10 Day Streak Unlocked.5c9ebae.png";